import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FC, ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const PageIconHeader: FC<{ icon: IconDefinition, children: ReactNode }> = (props) => {
  return <div className={"flex items-center mb-8"}>
    <div className={"h-16 w-16 bg-slate-100 text-brand-800 rounded-lg mr-4 flex items-center justify-center"}>
      <FontAwesomeIcon icon={props.icon} className={"text-3xl"} />
    </div>
    <div className={"flex flex-col justify-center -mb-6 pt-4"}>
      {props.children}
    </div>
  </div>
}
